import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, ScreenContainer, ContentFrame, LayoutControls, LayoutContent, LayoutContentCenter, } from '@pinwheel/origami';
import { fetchAccountInformation } from '../../state/slices/slice-dd-form';
import { useOpts } from '../../context';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useAppDispatch } from '../../state';
import { selectLinkToken, selectLinkTokenPayload, selectModalSessionId, selectUniqueUserId, } from '../../state/slices/slice-link-params';
import LoadingView from '../../views/Loading';
import ModalHeader from '../../components/ModalHeader';
import ddFormImage from '../../assets/dd-form.svg';
import { selectHasAttemptedDDS } from '../../state/slices/slice-link-api';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { ImageTitleLayout } from '../../components/ImageTitleLayout';
import TermsOfService from '../../TermsOfService';
var DDFormPrimer = function () {
    var opts = useOpts();
    var getLocalizedString = useGetLocalizedString();
    var _a = useDDFormContext(), error = _a.error, loading = _a.loading, userName = _a.userName, employerName = _a.employerName;
    var hasAttemptedDDS = useSelector(selectHasAttemptedDDS);
    var navigate = useLinkNavigate();
    var appDispatch = useAppDispatch();
    var linkToken = useSelector(selectLinkToken);
    var modalSessionId = useSelector(selectModalSessionId);
    var uniqueUserId = useSelector(selectUniqueUserId);
    var linkTokenPayload = useSelector(selectLinkTokenPayload);
    useEffect(function () {
        void appDispatch(fetchAccountInformation({ linkToken: linkToken, modalSessionId: modalSessionId, uniqueUserId: uniqueUserId }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (error) {
            navigate('/error');
        }
    });
    var handleBegin = useCallback(function () {
        opts.fireClientEvent('dd_form_begin', {});
        if (userName !== undefined &&
            employerName !== undefined &&
            hasAttemptedDDS) {
            navigate('/dd-form/confirmation-screen');
        }
        else if (employerName === undefined) {
            navigate('/dd-form/employer-name-entry');
        }
        else if (userName === undefined) {
            navigate('/dd-form/user-name-entry');
        }
        else {
            navigate('/dd-form/amount-selection');
        }
    }, [employerName, navigate, opts, userName, hasAttemptedDDS]);
    return loading || error ? (React.createElement(LoadingView, null)) : (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, null),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(LayoutContentCenter, { "data-testid": "DDFormPrimer" },
                    React.createElement(ImageTitleLayout, { title: getLocalizedString('CREATE_A_FORM'), subtitle: getLocalizedString('DD_FORM_PRIMER') },
                        React.createElement("img", { src: ddFormImage, alt: "logo-dd-form" })))),
            React.createElement(LayoutControls, null,
                linkTokenPayload.skipIntroScreen ? React.createElement(TermsOfService, null) : null,
                React.createElement(Button, { eventId: "DDForm-begin", dataTestId: "button-continue", onClick: handleBegin }, getLocalizedString('GET_STARTED'))))));
};
export default DDFormPrimer;
